// extracted by mini-css-extract-plugin
module.exports = {"amenity-list":"app-javascript-packs-listings-show-___Amenity__amenity-list___3Z8Pr","amenity-item":"app-javascript-packs-listings-show-___Amenity__amenity-item___30Cyf"};